import { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { Trans } from '@libs/i18n';

import { useLoadingContext } from '../../hooks';

export const GlobalLoading: FC = observer(() => {
  const { isLoading } = useLoadingContext();

  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 2,
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          minWidth: 200,
        }}
      >
        <CircularProgress />
        <Typography variant="body1">
          <Trans i18nKey={'components.loading.text'} />
        </Typography>
      </Box>
    </Box>
  );
});
